import React from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import { Controller, useForm } from "react-hook-form";
import CreateWithPathao from "../Pathao/CreateWithPathao";
import divisions from "../../../assets/json/bd_divisions.json";

const InvoiceDetailsEdit = ({
  InvoiceAllData,
  SetInvoiceAllData,
  Found,
  FoundCustomer,
  setFoundCustomer,
  deliveryService,
  setDeliveryService,
  pathaoCity,
  setPathaoCity,
  pathaoZone,
  setPathaoZone,
  pathaoArea,
  setPathaoArea,
  selectedDivision,
  setSelectedDivision,
  selectedDistrict,
  setSelectedDistrict,
  selectedTown,
  setSelectedTown,
  districtList,
  setDistrictList,
  upazillaList,
  setUpazillaList,
  selectLoading,
  setSelectLoading,
  customCharge,
  setCustomCharge,
  watchFields,
  setValue,
  control,
  register,
  handleDivisionChange,
  handleDistrictChange,
  handleTownChange,
  toPhoneHandle,
  fromCode,
  setFromCode,
  toCode,
  setToCode,
  invoice_delivery_type,
  setinvoice_delivery_type,
  invoice_discount_type,
  setinvoice_discount_type,
  invoice_delivery_charge,
  setinvoice_delivery_charge,
  delivery_charge,
  paymentType,
  invoice_payment_type,
  setinvoice_payment_type,
  paymentAllData,
  setPaymentAllData,
  clearPaymentALlData,
  handleInputs,
  paymentStatusDisabled = false,
}) => {
  return (
    <div className="bg-white cat-child ">
      <div
        className="d-flex align-items-center"
        style={{ padding: "20px 24px ", border: "0.5px solid #E0E0E0" }}
      >
        <h3 style={{ fontSize: "23px", marginTop: "6px", marginLeft: "12px" }}>
          Invoice Details
        </h3>
      </div>
      <div className="product-main createInvoiceInputContainer">
        <div className="row">
          <div className="col-12 col-md-6">
            <p>Invoice Number</p>
            <InputGroup className="mb-3">
              <Form.Control
                disabled
                aria-label="Username"
                placeholder="This will be generated automatically."
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>
          <div className="col-12 col-md-6">
            <p>Barcode</p>
            <InputGroup className="mb-3">
              <Form.Control
                disabled
                placeholder="This will be generated automatically"
                aria-label="Username"
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Invoice Date" />
            <div className="position-relative">
              <InputGroup className="mb-3">
                <Form.Control
                  type="date"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  placeholder="Select a date"
                  name="invoice_date"
                  value={InvoiceAllData["invoice_date"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </InputGroup>
            </div>
          </div>
          <div className="col-12 col-md-6 ">
            <RequiredLabel text={"Delivery Type"} />
            <div className="" style={{ height: "47px" }}>
              <Form.Select
                size="lg"
                placeholder="---Select---"
                onChange={(e) => setinvoice_delivery_type(e.target.value)}
                style={{
                  backgroundColor: "#FAFAFA",
                  fontSize: "16px",
                  height: "47px",
                  borderRadius: "8px",
                  color: "#828282",
                }}
              >
                <option value={0}>Regular</option>
                <option value={1}>Urgent</option>
              </Form.Select>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <RequiredLabel text="From Mobile" />
            <div className="d-flex phoneContainer ">
              <PhoneInput
                inputClass="phoneinput"
                disableDropdown
                onChange={(e) => setFromCode(e)}
                country={"bd"}
              />
              <div className="w-100">
                <Form.Control
                  aria-label="Input number"
                  placeholder="Input number"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  className="phone_insert_input"
                  name="invoice_from_mobile"
                  value={InvoiceAllData["invoice_from_mobile"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mb-3">
            <RequiredLabel text="To Mobile" />
            <div className="d-flex phoneContainer ">
              <PhoneInput
                inputClass="phoneinput"
                disableDropdown
                onChange={(e) => setToCode(e)}
                enableSearch={true}
                country={"bd"}
              />
              <div className="w-100">
                <Form.Control
                  aria-label="Input number"
                  placeholder="Input number"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  className="phone_insert_input"
                  name="invoice_to_mobile"
                  value={InvoiceAllData["invoice_to_mobile"]}
                  onChange={(e) => toPhoneHandle(e)}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 mt-3">
            <RequiredLabel text="Bill From" />
            <InputGroup className="mb-3">
              <Form.Control
                aria-label="Username"
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
                name="invoice_bill_from"
                value={InvoiceAllData["invoice_bill_from"]}
                onChange={(e) => handleInputs(e, SetInvoiceAllData)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6 mt-3">
            <RequiredLabel text="Bill To" />
            <InputGroup className="mb-3">
              <Form.Control
                name="invoice_bill_to"
                value={InvoiceAllData["invoice_bill_to"]}
                onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                aria-label="Username"
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text={"Discount Type"} />
            <div className="mb-3" style={{ height: "47px" }}>
              <Form.Select
                size="lg"
                placeholder="---Select---"
                onChange={(e) => setinvoice_discount_type(e.target.value)}
                style={{
                  backgroundColor: "#FAFAFA",
                  fontSize: "16px",
                  height: "47px",
                  borderRadius: "8px",
                  color: "#828282",
                }}
                value={invoice_discount_type}
              >
                <option value={0}>Flat </option>
                <option value={1}>Percentage</option>
              </Form.Select>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text={"Delivery Charge"} />
            <div className="mb-3">
              <Form.Select
                size="lg"
                placeholder="---Select---"
                value={invoice_delivery_charge}
                onChange={(e) => {
                  if (Number(e.target.value) === 0) {
                    setCustomCharge(80);
                  } else if (Number(e.target.value) === 1) {
                    setCustomCharge(150);
                  }
                  setinvoice_delivery_charge(e.target.value);
                }}
                disabled
                style={{
                  backgroundColor: "#FAFAFA",
                  fontSize: "16px",
                  height: "47px",
                  borderRadius: "8px",
                  color: "#828282",
                }}
              >
                <option value={0}>Inside Dhaka : 80/-</option>
                <option value={1}>Outside Dhaka : 150/-</option>
                <option value={2}>Custom</option>
              </Form.Select>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="From Email" />
            <InputGroup className="mb-3">
              <Form.Control
                aria-label="Username"
                type="email"
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
                name="invoice_from_email"
                value={InvoiceAllData["invoice_from_email"]}
                onChange={(e) => handleInputs(e, SetInvoiceAllData)}
              />
            </InputGroup>
          </div>

          {Found ? (
            <div className="col-12 col-md-6 ">
              <p>To Email</p>
              <InputGroup className="mb-3">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  name="invoice_to_email"
                  type="email"
                  value={FoundCustomer.email}
                  onChange={(e) =>
                    setFoundCustomer({
                      ...FoundCustomer,
                      email: e.target.value,
                    })
                  }
                />
              </InputGroup>
            </div>
          ) : (
            <div className="col-12 col-md-6 ">
              <p>To Email</p>
              <InputGroup className="mb-3">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  name="invoice_to_email"
                  type="email"
                  value={InvoiceAllData["invoice_to_email"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </InputGroup>
            </div>
          )}

          <div className="col-12 col-md-6">
            <RequiredLabel text="From Address" />
            <InputGroup className="mb-3 addressInput">
              <Form.Control
                aria-label="Username"
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
                name="invoice_from_address"
                value={InvoiceAllData["invoice_from_address"]}
                onChange={(e) => handleInputs(e, SetInvoiceAllData)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6"></div>
          <div className="col-12 col-md-6">
            <p>To Address 1</p>
            <InputGroup className="mb-3 addressInput">
              <Form.Control
                aria-label="Username"
                name="invoice_to_address"
                value={
                  Found
                    ? FoundCustomer.to_address
                    : InvoiceAllData["invoice_to_address"]
                }
                onChange={(e) =>
                  Found
                    ? setFoundCustomer({
                        ...FoundCustomer,
                        to_address: e.target.value,
                      })
                    : handleInputs(e, SetInvoiceAllData)
                }
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>
          <div className="col-12 col-md-6">
            <p>To Address 2</p>
            <InputGroup className="mb-3 addressInput">
              <Form.Control
                aria-label="Username"
                name="invoice_to_address2"
                value={
                  Found
                    ? FoundCustomer.to_address2
                    : InvoiceAllData["invoice_to_address2"]
                }
                onChange={(e) =>
                  Found
                    ? setFoundCustomer({
                        ...FoundCustomer,
                        to_address: e.target.value,
                      })
                    : handleInputs(e, SetInvoiceAllData)
                }
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6 d-none">
            <RequiredLabel text="To Country" />
            <InputGroup className="mb-3 addressInput">
              <Form.Control
                aria-label="Username"
                name="to_country"
                value={
                  Found
                    ? FoundCustomer.to_country
                    : InvoiceAllData["to_country"]
                }
                onChange={(e) =>
                  Found
                    ? setFoundCustomer({
                        ...FoundCustomer,
                        to_country: e.target.value,
                      })
                    : handleInputs(e, SetInvoiceAllData)
                }
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Delivery Service" />
            <Select
              onChange={(newval) => setDeliveryService(newval)}
              options={[
                {
                  label: "Pathao",
                  value: 0,
                },
                {
                  label: "Others",
                  value: 1,
                },
              ]}
              value={deliveryService}
              placeholder="Select "
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                  boxShadow: state.isFocused
                    ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                    : "none",
                  "&:hover": {
                    borderColor: "#e0e0e0",
                  },
                  maxHeight: "120px",
                  overflowY: "auto",
                }),
                multiValueContainer: (baseStyles) => ({
                  ...baseStyles,
                  overflowY: "auto",
                  maxHeight: "120px",
                  display: "flex",
                  flexWrap: "wrap",
                }),
              }}
            />
          </div>
          {deliveryService?.value === 1 ? (
            <>
              <div className="col-12 col-md-6">
                <p>To Division</p>
                <Controller
                  name="division"
                  control={control}
                  render={({ field }) => (
                    <Select
                      isSearchable
                      {...field}
                      value={selectedDivision}
                      onChange={handleDivisionChange}
                      options={divisions.map(({ name, id }) => {
                        return { label: name, value: id };
                      })}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                          boxShadow: state.isFocused
                            ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                            : "none",
                          "&:hover": {
                            borderColor: "#e0e0e0",
                          },
                          maxHeight: "120px",
                          overflowY: "auto",
                        }),
                        multiValueContainer: (baseStyles) => ({
                          ...baseStyles,
                          overflowY: "auto",
                          maxHeight: "120px",
                          display: "flex",
                          flexWrap: "wrap",
                        }),
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-6">
                <p>To District</p>
                <Controller
                  name="district"
                  control={control}
                  render={({ field }) => (
                    <Select
                      isLoading={selectLoading}
                      isSearchable
                      {...field}
                      value={selectedDistrict}
                      onChange={handleDistrictChange}
                      options={districtList?.map(({ name, id }) => {
                        return { label: name, value: id };
                      })}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                          boxShadow: state.isFocused
                            ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                            : "none",
                          "&:hover": {
                            borderColor: "#e0e0e0",
                          },
                          maxHeight: "120px",
                          overflowY: "auto",
                        }),
                        multiValueContainer: (baseStyles) => ({
                          ...baseStyles,
                          overflowY: "auto",
                          maxHeight: "120px",
                          display: "flex",
                          flexWrap: "wrap",
                        }),
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-6">
                <p>To City</p>
                <Controller
                  name="town"
                  control={control}
                  render={({ field }) => (
                    <Select
                      isSearchable
                      {...field}
                      value={selectedTown}
                      onChange={handleTownChange}
                      options={upazillaList?.map(({ name, id }) => {
                        return { label: name, value: id };
                      })}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                          boxShadow: state.isFocused
                            ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                            : "none",
                          "&:hover": {
                            borderColor: "#e0e0e0",
                          },
                          maxHeight: "120px",
                          overflowY: "auto",
                        }),
                        multiValueContainer: (baseStyles) => ({
                          ...baseStyles,
                          overflowY: "auto",
                          maxHeight: "120px",
                          display: "flex",
                          flexWrap: "wrap",
                        }),
                      }}
                    />
                  )}
                />
              </div>
            </>
          ) : (
            <>
              <CreateWithPathao
                pathaoCity={pathaoCity}
                setPathaoCity={setPathaoCity}
                pathaoZone={pathaoZone}
                setPathaoZone={setPathaoZone}
                pathaoArea={pathaoArea}
                setPathaoArea={setPathaoArea}
                mainState={{}}
                setCustomCharge={setCustomCharge}
                subTotal={0}
              />
            </>
          )}

          <div className="col-12 col-md-6 mt-2">
            <p>Post Code</p>
            <input style={{ width: "100%" }} type="text" {...register("zip")} />
          </div>
          <div className="col-12 col-md-6 mt-2">
            <RequiredLabel text={"Payment Type"} />
            <div className="mb-3">
              <Form.Select
              disabled={paymentStatusDisabled}
                size="lg"
                placeholder="---Select---"
                value={String(invoice_payment_type ?? 0)}
                onChange={(e) => {
                  clearPaymentALlData();
                  setinvoice_payment_type(Number(e.target.value));
                }}
                style={{
                  backgroundColor: "#FAFAFA",
                  fontSize: "16px",
                  height: "47px",
                  borderRadius: "8px",
                  color: "#828282",
                }}
              >
                {paymentType.map((curr) => {
                  return (
                    <option key={curr.value} value={curr.value}>
                      {curr.label}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <p>Reference ID</p>
            <InputGroup className="mb-3 addressInput">
              <Form.Control
                aria-label="Username"
                name="reference_id"
                value={paymentAllData["reference_id"]}
                onChange={(e) => handleInputs(e, setPaymentAllData)}
                aria-describedby="basic-addon1"
                style={{ backgroundColor: "#FAFAFA" }}
              />
            </InputGroup>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetailsEdit;
